import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-valetstation',
    templateUrl: './valetstation.component.html',
    styleUrls: ['./valetstation.component.scss'],
    standalone: false
})
export class ValetStationComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;

  // Mirror of FrogOne.ModelDefinitions.Parking.Valet.ValetStationPaymentTerminalType
  public TerminalTypes: { Id: number, Name: string }[] = [
    { Id: 0, Name: 'Windcave HIT' }
  ];

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, public router: Router) {
    super();
  }

  public TerminalTypeName(terminalType: number): string {
    let match = this.TerminalTypes.find(t => t.Id == terminalType);
    return match ? match.Name : 'Unknown';
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("valet/stations/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }
}
